export { default } from './Pay';
